module.exports = {"title":"選擇註冊模式＆獲取註冊資訊","plateFormBaseDescription":"利用此模式註冊節點後，可將節點調配給任意群組，並且使用防禦模式。","groupTokenBaseDescription":"此模式可以註冊專屬於這個群組的節點。","nextStep":"下一步","preStep":"上一步","gotIt":"了解","step1":"步驟一","step2":"步驟二","selected":"已選擇","select":"選擇","inUsed":"使用中","noVailableText":"沒有可使用的令牌","revoke":"撤銷","revokeRemindText":"此動作將會讓對應到此令牌的節點失效，確定要撤銷此令牌嗎？"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/nodeRegisteration.json
// module id = oLZ1
// module chunks = 3